import React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

import {
  EuiSpacer,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem
} from '@elastic/eui'

export default function LatestArticle() {

  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Alarm_Menu/Actions/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Alarm_Menu/1080pCGIs-WebUI_Alarm_Actions.webp'
                    alt="1080p Serie CGI List - Alarm Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Actions"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Alarm_Menu/Areas/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Alarm_Menu/1080pCGIs-WebUI_Alarm_Areas.webp'
                    alt="1080p Serie CGI List - Alarm Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Areas"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Alarm_Menu/Push_Service/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Alarm_Menu/1080pCGIs-WebUI_Alarm_Push.webp'
                    alt="1080p Serie CGI List - Alarm Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Push Service"
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Alarm_Menu/Schedule/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Alarm_Menu/1080pCGIs-WebUI_Alarm_Schedule.webp'
                    alt="1080p Serie CGI List - Alarm Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Schedule"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Serie_CGI_Befehle/Alarm_Menu/Alarm_Server/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Alarm_Menu/1080pCGIs-WebUI_Alarm_Server.webp'
                    alt="1080p Serie CGI List - Alarm Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Alarm Server"
            />
          </EuiFlexItem>
          <EuiFlexItem>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
